import React from 'react'
import Navbar from './Navbar'
import logo from './teamPhoto.png'
import collection from 'easter-egg-collection';




class Main extends React.Component{


    render(){    
        return(
            <main data-aos="fade-in" data-aos-duration="1000">
                <link rel="stylesheet" href="../index.css"/>

                <Navbar />

                <div className="teamPhoto">
                    <img src={logo} alt="Group Photograph" className="img-header"/>
                    <div className="centered">Hi, we are eSpice! <br/> The Tech club of Delhi Public School, Noida.</div>
                    <div className="bottom-centered">
                        <div className="arrow">
                            <a href="#home"></a>
                        </div>
                    </div>
                </div>

                <p className="mirchi" data-aos="flip-up" data-aos-duration="1000">#MirchiTohLagegi</p>

                <div id="home">
                    <p className="desc-heading" data-aos="fade-up">What we do</p>
                    <p className="desc" data-aos="fade-up">As part of the Delhi NCR Tech Circuit, a network of highschool techies, we compete in interschool competitions and more importantly help each other in the circuit. We also create our own collaborative projects within the club, and often launch new initiatives. <br/>The major fields we specialise in are Software Development & Design </p>
                    <p className="desc-heading" data-aos="fade-up">What We Aspire to be</p>
                    <p className="desc" data-aos="fade-up">Grounded, high skilled members, from grade 6 to 12 of an exclusive-yet-inclusive club, who’re always there to help those who need it and ready to make the most of it.</p>
                    <p className="desc-heading" data-aos="fade-up">Club History</p>
                    <p className="desc" data-aos="fade-up">We started in 2003 as a group of passionate techies along with our founding teacher, Ms Monica Dewan. Want to know a lot more, just read our <a href="https://wikipedia.com">Wikipedia</a>.</p>
                </div>
            </main>
        )
    }
}

export default Main